"use strict";
var $ = require("../internals/export");
var arrayWith = require("../internals/array-with");
var toIndexedObject = require("../internals/to-indexed-object");
var $Array = Array;
var INCORRECT_EXCEPTION_ON_COERCION_FAIL = function() {
  try {
    []["with"]({ valueOf: function() {
      throw 4;
    } }, null);
  } catch (error) {
    return error !== 4;
  }
}();
$({ target: "Array", proto: true, forced: INCORRECT_EXCEPTION_ON_COERCION_FAIL }, {
  "with": function(index, value) {
    return arrayWith(toIndexedObject(this), $Array, index, value);
  }
});
